import { Link } from 'react-router-dom';
import { XCircle, Citrus } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export default function PaymentCancel() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-brand-cream text-brand-green flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border-2 border-brand-green/15 rounded-3xl p-10 shadow-xl text-center space-y-6" data-testid="payment-cancel-page">
        <div className="w-14 h-14 rounded-full bg-brand-green mx-auto flex items-center justify-center text-white -rotate-6">
          <Citrus className="w-7 h-7" />
        </div>
        <h1 className="font-display text-4xl uppercase text-brand-green">{t.cancel.title}</h1>
        <div className="space-y-3">
          <XCircle className="w-10 h-10 text-brand-orange mx-auto" />
          <p className="text-sm text-brand-green/80 leading-relaxed">{t.cancel.text}</p>
        </div>
        <Link
          to="/#order"
          data-testid="cancel-back-checkout-btn"
          className="inline-flex items-center justify-center px-8 py-3 rounded-2xl bg-brand-orange text-white text-sm font-extrabold uppercase tracking-wide hover:bg-brand-citrus transition-colors shadow-lg citrus-glow"
        >
          {t.cancel.back}
        </Link>
      </div>
    </div>
  );
}
